import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AccordionModule } from '@openng/optimus-ui/accordion';
import { AvatarModule } from '@openng/optimus-ui/avatar';
import { ButtonModule } from '@openng/optimus-ui/button';
import { DividerModule } from '@openng/optimus-ui/divider';
import { BaseDialogComponent } from '../../../../components/kit/base-dialog/base-dialog.component';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@openng/optimus-ui/tabs';
import { RecentlyVisitedComponent } from '../recently-visited/recently-visited.component';
import NotificationsComponent from '../notifications/notifications.component';
import { DynamicDialogConfig } from '@openng/optimus-ui/dynamicdialog';

@Component({
    selector: 'app-notifications-center',
    templateUrl: './notifications-center.component.html',
    styleUrls: ['./notifications-center.component.scss'],
    imports: [
        TranslatePipe,
        AccordionModule,
        AvatarModule,
        DividerModule,
        ButtonModule,
        Tab,
        TabList,
        TabPanel,
        TabPanels,
        Tabs,
        RecentlyVisitedComponent,
        NotificationsComponent,
    ],
})
export class NotificationsCenterComponent extends BaseDialogComponent {
    private readonly config = inject(DynamicDialogConfig);
    protected readonly activeTab = this.config.data?.tab || 'notifications';
}
